import { render, staticRenderFns } from "./QuotationCreate.vue?vue&type=template&id=9f6f787c&scoped=true&"
import script from "./QuotationCreate.vue?vue&type=script&lang=js&"
export * from "./QuotationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6f787c",
  null
  
)

export default component.exports